import { InlineLoader, Translation } from '@jsverse/transloco';

export function createInlineLoader(
  translations: Record<string, Translation>,
): InlineLoader {
  const loader: Record<string, () => Promise<Translation>> = {};

  for (const lang of Object.keys(translations)) {
    const translation = translations[lang];
    loader[lang] = async () => translation;
  }

  return loader as InlineLoader;
}
